module.exports = __webpack_public_path__ + "img/3bhk-a2.732ce8a4.jpg";